import { FC, ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { Content } from './content';
import { Footer } from './footer';
import { Header } from './header';
import { LeftMenu } from './left-menu';
import { Peel } from './peel';
import { Scrollable } from '../../styles';

interface Props {
  $gray?: boolean;
  outlineWidth?: number;
  $showHeaderBorder?: boolean;
  tabs?: ReactNode;
}

const PageComponent = styled.div.attrs({ id: 'page' })<Props>`
  flex: 1 1 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
  /* margin: 8px 8px 8px 0px; */
  border-radius: var(--border-radius-small);
  ${({ outlineWidth = 0 }) =>
    outlineWidth !== 0
      ? css`
          //height: calc(100vh - ${2 * outlineWidth}px);
          /* margin: ${outlineWidth}px; */
          border-radius: var(--border-radius-default);
        `
      : ''};

  ${Scrollable};

  ${({ $gray }) => css`
    background: ${$gray ? 'var(--coolest-gray-10)' : 'var(--white-100)'};
  `};

  ${Header} {
    width: 100%;
    border-bottom: ${({ $showHeaderBorder: $showBorderBottom = false }) =>
      $showBorderBottom ? '1px solid var(--divider-default)' : 'none'};
    z-index: var(--zindex-layer-${({ theme }) => `0${theme.header.layer}`});
    flex: 0 0 auto;
    position: relative;
  }
`;

type Page = typeof PageComponent & {
  Header: typeof Header;
  Content: typeof Content;
  Peel: typeof Peel;
  Footer: typeof Footer;
  LeftMenu: typeof LeftMenu;
};

const Page: Page = PageComponent as any;

Page.Header = Header;
Page.Content = Content;
Page.Peel = Peel;
Page.Footer = Footer;
Page.LeftMenu = LeftMenu;

export const HeaderWithIconTitle: FC<
  React.PropsWithChildren<{
    icon: ReactNode;
    title: string | React.JSX.Element;
  }>
> = ({ icon, title }) => {
  return (
    <Page.Header.Title>
      <Page.Header.Title.Icon>{icon}</Page.Header.Title.Icon>
      <Page.Header.Title.Text>{title}</Page.Header.Title.Text>
    </Page.Header.Title>
  );
};

export { Page };
